<template>
  <div>
    <div v-if="!VATLoaded" class="text-center">
      <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
    </div>
    <b-container v-else fluid>
      <b-row>
        <b-col class="pb-3" cols="12" sm="6">
          <div class="d-flex">
            <strong class="text-uppercase font-weight-bold kub-color">{{billingAddressData.heading}}</strong>
            <b-icon icon="pencil" v-b-tooltip.hover title="Bearbeiten" scale="1.15" class="align-self-center ml-auto" :style="xl ? 'margin-right:60%;' : 'margin-right:1%;'" @click="changeAdress(), changeView({x: 0, y: 0})" style="cursor:pointer;"></b-icon>
          </div>
          <ul class="p-0 m-0 mt-2" style="list-style:none;">
            <li v-if="isCompany">
              {{billingAddress.company}}
            </li>
            <li>
              {{billingAddress.title != 'Divers' ? billingAddress.title : ''}} {{billingAddress.firstName}} {{billingAddress.lastName}}
            </li>
            <li>
              {{billingAddress.street}} {{billingAddress.number}}
            </li>
            <li>
              {{billingAddress.addition}}
            </li>
            <li>
              {{billingAddress.zip}} {{billingAddress.city}}
            </li>
            <li class="pb-3">
              {{billingAddress.country.name}}
            </li>
            <li v-if="isCompany">
              {{billingAddressData.salesTax.label}}: {{billingAddress.salesTax}}
            </li>
            <li>
              {{billingAddressData.phone.label}}: {{billingAddress.phone}}
            </li>
            <li>
              {{billingAddressData.mail.title}}: {{billingAddress.mail}}
            </li>
          </ul>
        </b-col>
        <b-col class="pb-3" cols="12" sm="6">
          <div class="d-flex">
            <strong class="text-uppercase font-weight-bold kub-color">{{deliveryAddressData.heading}}</strong>
            <b-icon icon="pencil" v-b-tooltip.hover title="Bearbeiten" scale="1.15" class="align-self-center ml-auto" :style="xl ? 'margin-right:60%;' : 'margin-right:1%;'" @click="changeAdress(), changeView({x: 0, y: 0})" style="cursor:pointer;"></b-icon>
          </div>
          <ul class="p-0 m-0 mt-2" style="list-style:none;" v-if="!checkDelivery">
            <li v-if="isCompany">
              {{billingAddress.company}}
            </li>
            <li>
              {{billingAddress.title != 'Divers' ? billingAddress.title : ''}} {{billingAddress.firstName}} {{billingAddress.lastName}}
            </li>
            <li>
              {{billingAddress.street}} {{billingAddress.number}}
            </li>
            <li>
              {{billingAddress.addition}}
            </li>
            <li>
              {{billingAddress.zip}} {{billingAddress.city}}
            </li>
            <li class="pb-3">
              {{billingAddress.country.name}}
            </li>
          </ul>
          <ul class="p-0 m-0 mt-2" style="list-style:none;" v-else>
            <li>
              {{deliveryAddress.company}}
            </li>
            <li>
              {{deliveryAddress.title != 'Divers' ? deliveryAddress.title : ''}} {{deliveryAddress.firstName}} {{deliveryAddress.lastName}}
            </li>
            <li>
              {{deliveryAddress.street}} {{deliveryAddress.number}}
            </li>
            <li>
              {{deliveryAddress.addition}}
            </li>
            <li>
              {{deliveryAddress.zip}} {{deliveryAddress.city}}
            </li>
            <li class="pb-3">
              {{deliveryAddress.country.name}}
            </li>
            <li>
              {{deliveryAddressData.phone.label}}: {{deliveryAddress.phone}}
            </li>
          </ul>
        </b-col>
      </b-row>
      <b-row class="pt-3">
        <b-col>
          <div class="d-flex mb-3">
            <strong class="text-uppercase font-weight-bold kub-color">{{payment.summary.title}}</strong>
            <b-icon icon="pencil" v-b-tooltip.hover title="Bearbeiten" scale="1.15" class="align-self-center ml-auto" :style="xl ? 'margin-right:80%;' : 'margin-right:1%;'" @click="changeCart(), changeView({x: 0, y: 0})" style="cursor:pointer;"></b-icon>
          </div>
        </b-col>
      </b-row>
      <b-table-simple id="kub-orderSummary" stacked="md">
        <b-thead>
          <b-tr>
            <b-th class="text-uppercase kub-no-border kub-color">{{cart.table.headings.position}}</b-th>
            <b-th class="text-uppercase kub-no-border kub-color">{{cart.table.headings.article}}</b-th>
            <b-th class="text-uppercase kub-no-border kub-color text-right">{{cart.table.headings.quantity}}</b-th>
            <b-th class="text-uppercase kub-no-border kub-color text-right">{{cart.table.headings.unitPrice}}</b-th>
            <b-th class="text-uppercase kub-no-border kub-color text-right">{{cart.table.headings.sumPrice}}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(configuration, index) in configurationList" :key="index">
            <b-td :class="{'kub-border-top': !md}">
              <b-row class="align-items-center">
                <b-col class="pr-0 d-md-none">
                  <div class="align-self-center text-uppercase font-weight-bold float-left kub-color">{{cart.table.headings.position}}</div>
                </b-col>
                <b-col>
                  <div :class="{'float-right': !md}">{{index + 1}}</div>
                </b-col>
              </b-row>
            </b-td>
            <b-td :class="{'kub-no-border': !md}">
              <b-card no-body class="overflow-hidden kub-no-border">
                <b-row no-gutters>
                  <b-col cols="12" sm="3">
                    <div class="d-inline-block">
                      <svg class="kub-payment-img" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                        <component :is="configuration.form.img" :material="configuration.material" :rand="configuration.rand"></component>
                      </svg>
                    </div>
                  </b-col>
                  <b-col cols="12" sm="9">
                    <b-card-body :class="[{'pt-0': true}, {'pr-0': true}, {'pb-0': true}, {'p-0': xs}]">
                      <b-card-text>
                        <b-container fluid>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.form}}</b-col>
                            <b-col cols="12" xl="10">{{configuration.form.type}}</b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.size}}</b-col>
                            <b-col cols="12" xl="10">
                              <ul class="p-0 m-0" style="list-style:none;">
                                <li v-for="(side, sideName, index) in configuration.form.size" :key="index">
                                  {{sideName === sides[3] ? 'Durchmesser' : (sideName === sides[4] ? 'Höhe' : 'Grundseite')}} {{sideName}}: {{side}} cm
                                </li>
                              </ul>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.material}}</b-col>
                            <b-col cols="12" xl="10">{{configuration.material.type}}</b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.color}}</b-col>
                            <b-col cols="12" xl="10">{{configuration.material.color.color}}</b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.rand}}</b-col>
                            <b-col cols="12" xl="10">
                              <ul class="p-0 m-0" style="list-style:none;">
                                <li v-for="(side, sideName, index) in configuration.rand" :key="index">
                                  {{sideName}}:
                                  <span v-for="(char, charName, index) in side" :key="index">{{char}}
                                    <span v-if="charName === 'oesenAnzahl'"> Stück </span>
                                    <span v-if="char === 'Hohlschnitt'">eingenähtes Gurtband, D-Ring</span>
                                  </span>
                                </li>
                              </ul>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.note}}</b-col>
                            <b-col cols="12" xl="10">
                              <div class="mb-1">{{configuration.note === '' ? '&ndash;' : configuration.note}}</div>
                              <div v-if="configuration.oesenTotal > 0">Gesamt: {{configuration.oesenTotal}} Ösen{{configuration.drehverschluss ? ' inkl. Drehverschlüsse' : ''}}</div>
                              <div v-if="configuration.hohlsaum">Hohlsaum flach gemessen</div>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-td>
            <b-td :class="{'kub-no-border': !md}">
              <b-row class="align-items-center">
                <b-col class="pr-0 d-md-none">
                  <div class="align-self-center text-uppercase font-weight-bold float-left kub-color">{{cart.table.headings.quantity}}</div>
                </b-col>
                <b-col>
                  <div class="float-right">{{configuration.quantity}}</div>
                </b-col>
              </b-row>
            </b-td>
            <b-td :class="{'kub-no-border': !md}">
              <b-row>
                <b-col class="d-md-none">
                  <div class="text-uppercase font-weight-bold float-left kub-color">{{cart.table.headings.unitPrice}}</div>
                </b-col>
                <b-col>
                  <div class="float-right">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(roundPrice(checkVAT ? configuration.price / (1 + VATRate) : configuration.price))}}</div>
                </b-col>
              </b-row>
            </b-td>
            <b-td :class="{'kub-no-border': !md}">
              <b-row>
                <b-col class="d-md-none">
                  <div class="text-uppercase font-weight-bold float-left kub-color">{{cart.table.headings.sumPrice}}</div>
                </b-col>
                <b-col>
                  <div class="float-right">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(roundPrice(roundPrice(checkVAT ? (configuration.price / (1 + VATRate)) : configuration.price) * configuration.quantity))}}</div>
                </b-col>
              </b-row>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-row id="kub-orderSummary-total" class="py-3 mb-4 rounded">
        <b-col cols="12" offset-xl="6" xl="6">
          <ul class="p-0" style="list-style:none;">
            <li>
              <b-row>
                <b-col cols="8">
                  <span :class="{'kub-padding-left': sm}">{{payment.summary.sum}} <small>{{payment.summary.taxBefore}} {{checkVAT ? '0%' : ''}} {{payment.summary.taxAfter}}</small></span>
                </b-col>
                <b-col cols="4" class="text-right">
                  <span :class="{'kub-padding-right': sm}">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcSumPriceVAT)}}</span>
                </b-col>
              </b-row>
            </li>
            <li>
              <b-row>
                <b-col>
                  <b-button href="#" v-b-toggle.kub-coupon variant="link" class="text-decoration-none text-left kub-btn-coupon" :class="{'pl-0': xs}">
                    <span id="kub-btn-coupon-font">{{payment.coupon.title}}</span>
                  </b-button>
                  <b-collapse id="kub-coupon" class="pt-1" :class="[{'kub-padding-left': sm}, {'kub-padding-right': sm}]">
                      <div v-if="couponActive">
                        <b-row>
                          <b-col cols="8">
                            {{coupon.code}}
                          </b-col>
                          <b-col v-if="calcSumPriceVAT >= coupon.minOrder" cols="4" class="text-right">
                            -{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(discount)}}
                          </b-col>
                          <b-col v-else cols="4" class="text-right">
                            {{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(discount)}}
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <small>({{coupon.type}})</small>
                          </b-col>
                        </b-row>
                        <b-row v-if="calcSumPriceVAT < coupon.minOrder">
                          <b-col>
                            <small class="kub-color-red font-weight-bold">Es fehlen noch {{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(roundPrice(coupon.minOrder - calcSumPriceVAT))}}</small>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-else>
                        <b-input-group id="kub-coupon-input">
                          <b-form-input v-model="couponInput" :formatter="formatter"></b-form-input>
                          <b-input-group-append>
                            <b-button href="#" variant="link" class="kub-btn-filled text-decoration-none" @click="checkCoupon">
                              <b-icon-chevron-right scale="0.8"></b-icon-chevron-right>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <b-alert
                          id="kub-coupon-alert"
                          class="mt-2 kub-alert-danger"
                          :show="couponFailed"
                          @dismissed="couponFailed=false"
                          dismissible
                          fade
                        >
                          {{payment.coupon.error}}
                        </b-alert>
                      </div>
                  </b-collapse>
                </b-col>
              </b-row>
            </li>
            <li>
              <b-row class="pt-2">
                <b-col cols="8">
                  <span :class="{'kub-padding-left': sm}"><span @click="$bvModal.show('kub-payment-shippingCosts')" class="kub-btn-shipping">{{shippingCosts.altTitle}}</span></span>
                </b-col>
                <b-col cols="4" class="text-right">
                  <span :class="{'kub-padding-right': sm}">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcShippingCost)}}</span>
                </b-col>
              </b-row>
              <b-modal id="kub-payment-shippingCosts" centered :title="shippingCosts.title" title-tag="h2">
                <app-shipping-costs></app-shipping-costs>
                <template #modal-footer="{ ok }">
                  <b-button class="kub-btn" size="sm" @click="ok()">
                    <span class="pl-2 pr-2">OK</span>
                  </b-button>
                </template>
              </b-modal>
            </li>
            <li>
              <b-row class="pt-3">
                <b-col cols="8">
                  <div class="text-uppercase font-weight-bold" :class="{'kub-padding-left': sm}">{{payment.summary.total}}</div>
                </b-col>
                <b-col cols="4" class="text-right">
                  <span class="text-uppercase font-weight-bold" :class="{'kub-padding-right': sm}">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(roundPrice(calcSumPriceVAT - discount + calcShippingCost))}}</span>
                </b-col>
              </b-row>
            </li>
          </ul>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" offset-xl="6" xl="6">
          <b-form>
            <div class="pb-2">Bitte beachten Sie unsere <strong v-b-modal.kub-disclaimer class="kub-color kub-underline">Widerrufsbelehrung</strong>.</div>
            <b-modal id="kub-disclaimer" centered scrollable size="xl" title="Widerrufsrecht" title-tag="h2">
              <app-disclaimer></app-disclaimer>
              <template #modal-footer="{ ok }">
                <b-button class="kub-btn" size="sm" @click="ok()">
                  <span class="pl-2 pr-2">OK</span>
                </b-button>
              </template>
            </b-modal>
            <b-form-checkbox
              id="termsAndConditions"
              size="sm"
              v-model="checkedTermsAndConditions"
              :state="checkTermsAndConditions"
              plain
            >
              Ich habe die <strong v-b-modal.kub-payment-termsAndConditions class="kub-color kub-underline">Allgemeinen Geschäftsbedingungen</strong> und die <strong v-b-modal.kub-payment-privacy class="kub-color kub-underline">Datenschutzerklärung</strong> gelesen und stimme ihnen zu.
            </b-form-checkbox>
            <b-modal id="kub-payment-termsAndConditions" centered scrollable size="xl" title="Allgemeine Geschäftsbedingungen" title-tag="h2">
              <app-terms></app-terms>
              <template #modal-footer="{ ok }">
                <b-button class="kub-btn" size="sm" @click="ok()">
                  <span class="pl-2 pr-2">OK</span>
                </b-button>
              </template>
            </b-modal>
            <b-modal id="kub-payment-privacy" centered scrollable size="xl" title="Datenschutzerklärung" title-tag="h2">
              <app-privacy></app-privacy>
              <template #modal-footer="{ ok }">
                <b-button class="kub-btn" size="sm" @click="ok()">
                  <span class="pl-2 pr-2">OK</span>
                </b-button>
              </template>
            </b-modal>
            <b-modal id="kub-acceptTermsAndConditions" centered>
              Bitte stimmen Sie den <strong>Allgemeinen Geschäftsbedingungen</strong> und der <strong>Datenschutzerklärung</strong> zu.
              <template #modal-footer="{ ok }">
                <b-button class="kub-btn" size="sm" @click="ok()">
                  <span class="pl-2 pr-2">OK</span>
                </b-button>
              </template>
            </b-modal>
            <b-form-checkbox
              size="sm"
              v-model="checkedNewsletter"
              plain
            >
              Ich möchte mich zum <strong class="kub-color">Newsletter</strong> anmelden und regelmäßig über neue Produkte, interessante Inhalte und aktuelle Rabattaktionen informiert werden. Eine Abmeldung ist jederzeit möglich.
            </b-form-checkbox>
            <div class="mx-auto" style="max-width:750px;">
              <div class="mt-4 font-weight-bold">Jetzt kostenpflichtig bestellen:</div>
              <b-button id="kub-btn-bill" type="submit" href="#" block variant="link" class="kub-btn-filled text-decoration-none mt-1 d-flex align-items-center justify-content-center" @click="submitPayment">
                <span>Kauf auf Rechnung*</span>
              </b-button>
              <div class="mb-2"><small>*7 Tage Zahlungsziel nach Erhalt der Ware</small></div>
              <paypal-buttons :on-approve="onApprove" :create-order="createOrder" :on-shipping-change="onShippingChange" :on-error="onError" :style-object="style" :on-init="onInit" :on-click="onClick"></paypal-buttons>
            </div>
          </b-form>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12" offset-xl="6" xl="6">
          <small>
            <strong>Hinweise:</strong>
            <ul style="list-style:disc;">
              <li>Maßanfertigungen sind grundsätzlich vom Umtausch ausgeschlossen. Beachten Sie hierzu auch unsere AGB.</li>
              <li>Die Maßtoleranz bei individuell konfektionierten Planen beträgt &plusmn; 1&percnt;. Maßabweichungen innerhalb dieser Toleranz stellen keinen Reklamationsgrund dar.</li>
              <li>Unsere Planen werden gefaltet in einem Paket versendet. Sich daraus eventuell ergebende Falten/Knicke haben keinen Einfluss auf die Haltbarkeit und stellen keinen Reklamationsgrund dar.</li>
            </ul>
          </small>
        </b-col>
      </b-row>
          <b-row class="mt-3">
            <b-col cols="12" offset-xl="6" xl="6" class="text-center">
            <img
              style="width: 100%; max-width: 794px; height: auto;"
              src="../../../../assets/img/legal/Gewaehrleistungslabel.svg"
              alt="Gewährleistungslabel"
            />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import cartDreieckGS from '../cart/forms/cartDreieckGS'
import cartDreieckGSE from '../cart/forms/cartDreieckGSE'
import cartDreieckRW from '../cart/forms/cartDreieckRW.vue'
import cartHalbkreis from '../cart/forms/cartHalbkreis.vue'
import cartHeptagon from '../cart/forms/cartHeptagon.vue'
import cartHexagon from '../cart/forms/cartHexagon.vue'
import cartKreis from '../cart/forms/cartKreis.vue'
import cartOktagon from '../cart/forms/cartOktagon.vue'
import cartPentagon from '../cart/forms/cartPentagon.vue'
import cartRechteck from '../cart/forms/cartRechteck.vue'
import cartTrapezGS from '../cart/forms/cartTrapezGS.vue'
import cartTrapezSSR from '../cart/forms/cartTrapezSSR.vue'
import cartTrapezSSL from '../cart/forms/cartTrapezSSL.vue'
import cartTrapezSOR from '../cart/forms/cartTrapezSOR.vue'
import cartTrapezSOL from '../cart/forms/cartTrapezSOL.vue'
import cartTrapezSER from '../cart/forms/cartTrapezSER.vue'
import cartTrapezSEL from '../cart/forms/cartTrapezSEL.vue'

import DataSummary from '../../../../data/main/summary/summary'
import DataAddress from '../../../../data/main/summary/address/address'
import DataPayment from '../../../../data/main/summary/payment/payment'
import DataCart from '../../../../data/main/summary/cart/cart'
import DataService from '../../../../services/DataService'
import ConfigService from '../../../../services/ConfigService'
import CouponService from '../../../../services/CouponService'
import { a, b, c, d, h } from '../../../../data/main/config/setup/form/sides'

import Disclaimer from './../../../general/Disclaimer.vue'
import Terms from './../../../general/Terms.vue'
import Privacy from './../../../general/Privacy.vue'
import shippingCosts from './../../config/ShippingCosts.vue'

import { mapGetters, mapActions } from 'vuex'

import { createHelpers } from 'vuex-map-fields'

const { mapMultiRowFields } = createHelpers({
  getterType: 'getConfigurationField',
  mutationType: 'updateConfigurationField'
})

export default {
  data () {
    return {
      summaryComponents: DataSummary.components,
      billingAddressData: DataAddress.billingAddress,
      deliveryAddressData: DataAddress.deliveryAddress,
      payment: DataPayment.payment,
      cart: DataCart.cart,
      checkedTermsAndConditions: null,
      checkedNewsletter: null,
      sides: [a.title, b.title, c.title, d.title, h.title],
      shippingCosts: {},
      couponInput: '',
      couponActive: false,
      couponFailed: false,
      coupon: {
        check: false
      },
      VAT: null
    }
  },
  components: {
    paypalButtons: window.paypal.Buttons.driver('vue', Vue),
    appDisclaimer: Disclaimer,
    appTerms: Terms,
    appPrivacy: Privacy,
    appShippingCosts: shippingCosts,
    cartDreieckGS,
    cartDreieckGSE,
    cartDreieckRW,
    cartHalbkreis,
    cartHeptagon,
    cartHexagon,
    cartKreis,
    cartOktagon,
    cartPentagon,
    cartRechteck,
    cartTrapezGS,
    cartTrapezSSR,
    cartTrapezSSL,
    cartTrapezSOR,
    cartTrapezSOL,
    cartTrapezSER,
    cartTrapezSEL
  },
  methods: {
    ...mapActions([
      'changeStatusShoppingCart',
      'changeStatusAddress',
      'changeStatusPayment',
      'changeView',
      'shippingLoadingError',
      'orderLoadingError',
      'orderLoadingComplete',
      'couponLoadingError'
    ]),
    changeAdress () {
      this.changeStatusAddress()
      this.$root.$emit('bv::toggle::collapse', this.summaryComponents.address.toggle)
    },
    changeCart () {
      this.changeStatusShoppingCart()
      this.changeStatusAddress()
      this.$root.$emit('bv::toggle::collapse', this.summaryComponents.shoppingCart.toggle)
    },
    async checkCoupon () {
      try {
        const couponChecked = await CouponService.checkCoupon({
          coupon: this.couponInput
        })
        if (couponChecked.data.check) {
          this.couponActive = true
          this.coupon = couponChecked.data
        } else {
          this.couponFailed = true
        }
      } catch (err) {
        this.couponLoadingError()
        console.log(err)
      }
    },
    async submitPayment () {
      if (this.checkedTermsAndConditions) {
        this.changeStatusPayment()
        this.$root.$emit('bv::toggle::collapse', this.summaryComponents.payment.toggle)
        try {
          await ConfigService.postConfiguration(
            {
              order: {
                code: this.confObjCodeList,
                name: this.confObjNameList
              },
              client: {
                checkDelivery: this.checkDelivery,
                isCompany: this.isCompany,
                billingAddress: this.billingAddress,
                deliveryAddress: this.deliveryAddress,
                selectedPayMethod: 'Rechnung',
                newsletter: this.checkedNewsletter
              },
              coupon: this.couponInput
            }
          )
          this.orderLoadingComplete()
        } catch (err) {
          this.orderLoadingError()
          console.log(err)
        }
      } else {
        this.checkedTermsAndConditions = false
        this.$bvModal.show('kub-acceptTermsAndConditions')
      }
    },
    formatter (value) {
      return value.toUpperCase()
    },
    roundPrice (value) {
      return Math.round((value + Number.EPSILON) * 100) / 100
    }
  },
  computed: {
    ...mapGetters([
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'isCompany',
      'billingAddress',
      'deliveryAddress',
      'configuration',
      'confObjCodeList',
      'confObjNameList',
      'calcSumPriceVAT',
      'calcShippingCost',
      'checkDelivery',
      'VATLoaded',
      'checkVAT',
      'paypalDeliveryAddress',
      'VATRate'
    ]),
    ...mapMultiRowFields([
      'configurationList'
    ]),
    checkTermsAndConditions () {
      if (this.checkedTermsAndConditions === null) {
        return null
      } else {
        return this.checkedTermsAndConditions
      }
    },
    discount () {
      if (this.coupon.check && this.calcSumPriceVAT >= this.coupon.minOrder) {
        if (this.coupon.token === 'g') {
          return this.roundPrice(this.coupon.value)
        } else if (this.coupon.token === 'r') {
          return this.roundPrice(this.calcSumPriceVAT * this.coupon.value)
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    onInit: function () {
      return (data, actions) => {
        actions.disable()
        document.querySelector('#termsAndConditions')
          .addEventListener('change', function (event) {
            if (event.target.checked) {
              actions.enable()
            } else {
              actions.disable()
            }
          })
      }
    },
    onClick: function () {
      return () => {
        if (!this.checkedTermsAndConditions) {
          this.checkedTermsAndConditions = false
          this.$bvModal.show('kub-acceptTermsAndConditions')
        }
      }
    },
    createOrder: function () {
      return (data, actions) => {
        const totalAmount = this.roundPrice(this.calcSumPriceVAT - this.discount + this.calcShippingCost)
        return actions.order.create({
          application_context: {
            shipping_preference: 'SET_PROVIDED_ADDRESS'
          },
          purchase_units: [
            {
              description: 'Vielen Dank für Ihre Bestellung bei KUBULUS!',
              amount: {
                value: totalAmount
              },
              shipping: {
                name: {
                  full_name: this.paypalDeliveryAddress.firstName + ' ' + this.paypalDeliveryAddress.lastName
                },
                address: {
                  address_line_1: this.paypalDeliveryAddress.street + ' ' + this.paypalDeliveryAddress.number,
                  admin_area_2: this.paypalDeliveryAddress.city,
                  postal_code: this.paypalDeliveryAddress.zip,
                  country_code: 'DE'
                }
              }
            }
          ]
        })
      }
    },
    onApprove: function () {
      return (data, actions) => {
        return actions.order.capture()
          .then(async () => {
            this.changeStatusPayment()
            this.$root.$emit('bv::toggle::collapse', this.summaryComponents.payment.toggle)
            try {
              await ConfigService.postConfiguration(
                {
                  order: {
                    code: this.confObjCodeList,
                    name: this.confObjNameList
                  },
                  client: {
                    checkDelivery: this.checkDelivery,
                    isCompany: this.isCompany,
                    billingAddress: this.billingAddress,
                    deliveryAddress: this.deliveryAddress,
                    selectedPayMethod: 'PayPal',
                    newsletter: this.checkedNewsletter
                  },
                  coupon: this.couponInput
                }
              )
              this.orderLoadingComplete()
            } catch (err) {
              this.orderLoadingError()
              console.log(err)
            }
          })
      }
    },
    onShippingChange: function () {
      return (data, actions) => {
        if (
          data.shipping_address.country_code !== 'DE' ||
          data.shipping_address.city !== this.paypalDeliveryAddress.city ||
          data.shipping_address.postal_code !== this.paypalDeliveryAddress.zip

        ) {
          return actions.reject()
        }
        return actions.resolve()
      }
    },
    onError: function () {
      return (err) => {
        console.error(err)
        this.orderLoadingError()
      }
    },
    style: function () {
      return {
        shape: 'rect',
        color: 'gold',
        layout: 'vertical',
        label: 'pay',
        tagline: false
      }
    }
  },
  async created () {
    try {
      this.shippingCosts = await DataService.getShipping()
      const basics = await DataService.getBasics()
      this.VAT = basics.B02.value
    } catch (err) {
      this.shippingLoadingError()
      console.log(err)
    }
  }
}
</script>

<style>
.kub-border-top {
  border-top: 1px solid #ddd;
}

.form-check-label {
  width: 100%;
}

#kub-orderSummary .card {
  min-width: 100%;
  margin-bottom: 1rem;
}

.kub-payment-img {
  width: 100% !important;
  height: auto !important;
  min-width: 120px;
  min-height: 120px;
  max-width: 200px;
  max-height: 200px;
}

#kub-orderSummary .card-header {
  border-bottom: none;
}

#kub-orderSummary td {
  padding-top: 32px !important;
}

#kub-orderSummary-total {
  border: 1px solid #dee2e6;
  background-color: #f4f6f6;
}

#kub-btn-coupon-font {
  color: #002b36;
  border-bottom: 1px solid #002b36;
  font-size: 1rem !important;
}

#kub-coupon-input, #kub-coupon-alert {
  max-width: 400px;
}

#kub-payment-icon-bill {
  height: 26px !important;
  width: 100px !important;
}

#kub-btn-bill {
  max-width: 750px;
  height: 55px;
  font-size:20px;
}

@media (max-width: 1500px) {
  #kub-btn-coupon-font {
    font-size: 0.9rem !important;
  }
}

@media (max-width: 992px) {
  #kub-btn-coupon-font {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 767px) {
  #kub-orderSummary td {
    padding-top: 12px !important;
  }
}

@media (max-width: 599px) {
  #kub-btn-bill {
    max-width: 750px;
    height: 45px;
    font-size:16px;
  }
}

@media (max-width: 575px) {
  .kub-payment-img {
    width: 120px !important;
    height: 120px !important;
    margin-bottom: 1rem;
    display: inline-block;
  }
}

@media (max-width: 399px) {
  #kub-btn-bill {
    max-width: 750px;
    height: 35px;
    font-size:13px;
  }
}
</style>
